export enum CopilotStudyLevel {
	MASTER = 'master',
	BACHELOR = 'bachelor',
	PHD = 'phd',
	SHORT = 'short'
}
